import pdfWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import { pdfjs } from 'react-pdf';

// Set once at module load. Vite serves the worker as a separate asset bundled
// with the app, so the version is guaranteed to match the installed
// pdfjs-dist and there is no runtime dependency on a third-party CDN.
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;
